import { faImage, faUserMagnifyingGlass, faVideo } from "@fortawesome/pro-regular-svg-icons";
import { faCheck, faCircleCheck, faCircleXmark, faTrash, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SLATE_GREY } from "theme";
import { DARK_BLUE, GREEN, RED } from "theme/colors";

export const iconColor = "rgb(56, 74, 95)";

export const iconStyles = {
  height: "24px",
  width: "24px",
};

const iconStylesSmall = {
  height: "18px",
  width: "18px",
};

export const CloseIcon = () => {
  return <FontAwesomeIcon icon={faXmark} color={DARK_BLUE[100]} style={{ height: "16px", width: "16px" }} />;
};

export const CheckIcon = () => {
  return <FontAwesomeIcon icon={faCheck} color={GREEN[100]} style={iconStylesSmall} />;
};

export const CircleCheckIcon = () => {
  return <FontAwesomeIcon icon={faCircleCheck} color={GREEN[100]} style={iconStylesSmall} />;
};

export const CircleXmarkIcon = () => {
  return <FontAwesomeIcon icon={faCircleXmark} color={RED[100]} style={iconStylesSmall} />;
};

export const UserMagnifyingGlassIcon = () => {
  return <FontAwesomeIcon icon={faUserMagnifyingGlass} style={iconStylesSmall} />;
};

export const DeleteIcon = () => {
  return <FontAwesomeIcon icon={faTrash} color={SLATE_GREY} style={iconStylesSmall} />;
};

interface Props {
  fontSize?: string;
}

export const PlaceholderImage = ({ fontSize }: Props) => {
  return <FontAwesomeIcon icon={faImage} style={{ fontSize: fontSize || "24px", color: DARK_BLUE[30] }} />;
};

export const PlaceholderVideo = ({ fontSize }: Props) => {
  return <FontAwesomeIcon icon={faVideo} style={{ fontSize: fontSize || "24px", color: DARK_BLUE[30] }} />;
};

export const XmarkIcon = () => {
  return <FontAwesomeIcon icon={faXmark} color={RED[100]} style={iconStylesSmall} />;
};
